import React from 'react';
import { isIos } from '../../utils';

const Body = (props)=> (
    <div>
      <div className={ isIos() ? ("main " + props.transitionClassName + " " + (props.className || "")) : "main " + (props.className || "") } id="maincontent" style={props.style || {}}>
        {props.children}
      </div>
      {isIos() && <div style={{ height: "80px" }}></div>}
    </div>
)

export default Body;
